function copyText() {
    $(document).on("click", ".copy-icon", function () {
        var $this = $(this);
        var $copyValue = $this.siblings(".copy-value");
        var $copyAlertPopup = $(".alert-popup");
        var copySuccessMessage = $copyValue.data("success");

        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText($copyValue.text().trim()).then(() => {
                if ($copyAlertPopup.length) {
                    $copyAlertPopup.text("");
                    $copyAlertPopup.append(copySuccessMessage);
                    $copyAlertPopup.removeClass("hide");
                    setTimeout(function () {
                        $copyAlertPopup.addClass("hide");
                    }, 5000);
                }
            }).catch(() => {
                return;
            });
        }
    });

    // Copies the product share URL to the clipboard and displays a success message.
    // Uses the modern Clipboard API when available. Falls back to a temporary input
    // appended inside the modal (instead of body) so Bootstrap's modal focus trap
    // doesn't steal focus away from the selection before document.execCommand('copy')
    // runs. The success message is only shown once the copy is confirmed.
    $("body").on("click", "#share-product-copy-link", function (event) {
        event.preventDefault();
        var $button = $(this);
        var shareUrl = $("#shareUrl").val();

        function showCopyMessage() {
            $(".copy-link-message").attr("role", "alert").removeClass("d-none");
            setTimeout(function () {
                $(".copy-link-message").addClass("d-none");
            }, 3000);
        }

        var fallbackCopy = function () {
            var $temp = $("<input>");
            $button.closest(".modal-content").append($temp);
            $temp.val(shareUrl).select();
            var copied;
            try {
                copied = document.execCommand("copy");
            } finally {
                $temp.remove();
            }
            if (copied) {
                showCopyMessage();
            }
        };

        if (navigator.clipboard?.writeText) {
            navigator.clipboard.writeText(shareUrl).then(showCopyMessage).catch(fallbackCopy);
        } else {
            fallbackCopy();
        }
    });
}

export default copyText;

